import React from "react"
import { sanitizer } from "@commonUtils"
import { useInView } from "react-intersection-observer"
import css from "./SupportSection.scss"

const SupportSection = ({ data, isBusinessVertical }) => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.1,
    })

    return (
        <section ref={ref} id="supportSection" className={css.supportSection}>
            <div
                className={`${css.fixedImage} hideMweb opacity-none height-100 ${
                    inView ? "slideRight" : ""
                } `}
            >
                <img className="height-100" src={data.statsImage.url} />
            </div>

            <div
                className={`container-fluid flexColumn page-container opacity-none
                     ${inView ? "slideUp" : ""} ${css.animationDelay}`}
            >
                <h2
                    className="sectionHeader col-13"
                    dangerouslySetInnerHTML={{
                        __html: sanitizer(data.header),
                    }}
                />
                <div className={`${css.fixedImage} hideDweb opacity-none ${inView ? "slideRight" : ""} `}>
                    <img className="width-100" src={data.statsImage.url} />
                </div>

                <h3
                    className={
                        isBusinessVertical
                            ? "detailsTextLarge marginBoth-40 col-14"
                            : "sectionSubHeader marginTop-56 marginBottom-16"
                    }
                    dangerouslySetInnerHTML={{
                        __html: sanitizer(data.listTitle),
                    }}
                />

                <div
                    className={`marginAll-0 ${
                        isBusinessVertical ? `col-15 ${css.gridList}` : ` col-10 flexColumn ${css.list}`
                    }`}
                >
                    {data.list.map((item, key) => {
                        return (
                            <div key={key}>
                                <div className={`flex alignCenter headingSmallMedium textPrimary`}>
                                    <img src={item.image.url} className={css.itemImg} alt="" />
                                    <span>&nbsp;&nbsp;</span>
                                    <h4
                                        className={
                                            isBusinessVertical
                                                ? `listTextBold ${css.listText}`
                                                : "padding-0-8 listItemHeader"
                                        }
                                    >
                                        {item.title}
                                    </h4>
                                </div>
                                <p className="detailsTextNormal marginTop-8">{item.description}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}

export default SupportSection
